export default{
    'request.auth.error.refresh': '認証情報をリフレッシュしました。再度操作をやり直してください。',
    'request.comm.error.no.response': 'レスポンスを取得できませんでした。再度操作をやり直してください。',
    'request.comm.error.request.fail': 'リクエストを送信できませんでした。再度操作をやり直してください。',
    'request.comm.error.fail': '通信できませんした。再度操作をやり直してください。',

    'request.comm.error.a0000e0001': 'トークンの有効期限がきれました。再度ログインしてください。',
    'request.comm.error.a0000e0002': 'このアカウントは無効です。',
    'request.comm.error.a0000e0003': 'リクエストパラメータが異常です。',
    'request.comm.error.a0000e9999': 'エラーが発生しました。繰り返すようであれば、システム管理者に問い合わせてください。',
    'request.comm.error.a0101e0001': 'ログインに失敗しました。',
    'request.comm.error.a0103e0001': 'トークンの有効期限がきれました。再度ログインしてください。',
    'request.comm.error.a0302e0001': '取得に失敗しました。指定したユーザーIDが存在しません。',
    'request.comm.error.a0303e0001': '登録に失敗しました。ユーザーIDが既に登録されています。',
    'request.comm.error.a0303e9999': 'エラーが発生しました。繰り返すようであれば、システム管理者に問い合わせてください。',
    'request.comm.error.a0304e0001': '更新に失敗しました。指定したユーザーIDが存在しません。',
    'request.comm.error.a0305e0001': '削除に失敗しました。指定したユーザーIDが存在しません。',
    'request.comm.error.a0402e0001': '取得に失敗しました。指定した契約者IDが存在しません。',
    'request.comm.error.a0403e0001': '登録に失敗しました。契約者IDが既に登録されています。',
    'request.comm.error.a0403e9999': 'エラーが発生しました。繰り返すようであれば、システム管理者に問い合わせてください。',
    'request.comm.error.a0404e0001': '更新に失敗しました。指定した契約者IDが存在しません。',
    'request.comm.error.a0405e0001': '削除に失敗しました。指定した契約者IDが存在しません。',

};
